module.exports = __webpack_public_path__ + "img/toolbox.0aead7e4.svg";